// import { Text } from '@pancakeswap-libs/uikit'
import styled from 'styled-components'

export const Wrapper = styled.div`
  position: relative;
  padding: 20px 15px;
`

export const ArrowIcon = styled.img<{ width: string, height: string}>`
  width: ${({ width }) => width};
  height: ${({ height }) => height};
`
export const Name = styled.div`
  color: #311765;
  font-size: 15px;
  margin-bottom: 10px;
  font-weight: bold;
  text-align: center;
  &.active{
    color: #1EC7D3;
  }
`
export const Desc = styled.div`
  color: #7A6EAA;
  font-size: 13px;
  text-align: center;
  &.address{
    flex: 1;
    margin-right: 10px;
    overflow: hidden;
    text-align: left;
    text-overflow: ellipsis;
  }
`
export const NoMore = styled.div`
  padding: 50px 0;
  font-size: 16px;
  color: #BDC2C4;
  text-align: center;
`
export const ListItem = styled.div`
  border-top: 1px solid #E7E3EB;
  &:first-child{
  border: none;
  }
`
export const Status = styled.div`
  color: #1EC7D3;
  font-size: 13px;
  font-weight: 600;
  &.red{
    color: #ff0000;
  }
  &.yellow{
    color: #FFA752;
  }
`
export const Title = styled.div`
  color: #311765;
  font-size: 15px;
  font-weight: bold;
  margin: 10px 0;
`
export const Time = styled.div`
  color: #7A6EAA;
  font-weight: 400;
  font-size: 13px;
`
export const TopBox = styled.div`
  display: flex;
  align-items: center;
  padding: 15px 20px;
  .left{
    flex: 1;
  }
`
export const DetailBtn = styled.div`
  display: flex;
  align-items: center;
  color: #1EC7D3;
  font-size: 14px;
  font-weight: 700;
  // cursor: pointer;
  span{
    margin-right: 6px;
  }
`
export const InputBox = styled.div`
  margin-bottom: 20px;
`
export const InputTitle = styled.div`
  font-size: 14px;
  color: #280D5F;
  margin-bottom: 10px;
`
export const WarnTip = styled.div`
  font-size: 13px;
  color: #280D5F;
  line-height: 23px;
  padding: 15px 15px;
  background: #FFF6E8;
  border: 1px solid #FFC323;
  border-radius: 12px;
  margin-bottom: 5px;
`
export const BottomBox = styled.div`
padding: 15px 20px;
 border-top: 1px solid #E7E3EB
`
export const ProgressBox = styled.div`
  margin: 20px 0 40px;
  .desc{
    text-align: center;
    font-size: 15px;
    color: #7A6EAA;
    margin-top: 10px;
    span{
      color: #2FCBD6;
    }
  }
`
export const Progress = styled.div`
  height: 16px;
  border-radius: 8px;
  background: rgba(0,0,0,0.1);
`
export const Bar = styled.div`
   background: #2FCBD6;
    height: 100%;
    border-radius: 8px;
`
